import React from 'react'
import { graphql, withApollo } from 'react-apollo'

import eventProducts from '~/App/graphql/queries/eventProducts.gql'
import { List, Button, Tag, Avatar } from 'antd'
import { inject, observer } from 'mobx-react'
// import gql from 'graphql-tag'
// import renderQuestionInput from '~/renderQuestionInput'
// import registrationQuery from '~/App/graphql/queries/registration.gql'
import orderRegistrationFragment from '~/App/graphql/fragments/orderRegistration.gql'
import withProps from 'recompose/withProps'
import _get from 'lodash/get'
import { FormattedNumber } from 'react-intl'
import localeGet from '~/App/utils/localeGet'
/*
{
  productId,

}

*/
// const optionFieldMap = {
//   Open: 'value',
//   Choice: 'itemId',
//   MultiChoice: 'itemIds'
// }
// @Form.create()
@withApollo
@withProps(({ client, registrationId }) => {
  // console.log({ registrationId })
  const registration = client.readFragment({
    id: `Registration:${registrationId}`,
    fragment: orderRegistrationFragment
  })
  // const { registration } = client.readQuery({
  //   query: registrationQuery,
  //   variables: {
  //     _id: registrationId
  //   }
  // })
  return {
    registration
  }
})
@graphql(eventProducts, {
  options: ({ registration }) => ({
    variables: ({
      eventId: registration.eventId
    })
  })
})
@inject('i18n')
@inject('router')
@observer
class ProductSelectModal extends React.Component {
  handleSelectProduct = (productId) => {
    const { location } = this.props.router
    location.query = {
      ...location.query
    }
  }

  onCancel = () => {
    const { location } = this.props.router
    const { pdId, ...query } = location.query
    location.query = query
  }

  render () {
    const { data, i18n: { locale }, registration } = this.props
    const { orderItems = [] } = registration
    // console.log({ registration, orderItems })
    // const { participants } = registration
    // const { getFieldDecorator, getFieldValue } = form
    if (data.loading) {
      return <div>Loading</div>
    }
    if (data.error) {
      return <div>Error</div>
    }
    // console.log('ProductSelectModal', this.props)
    // const products = data.products.filter(p=> !!p.crossSale)
    // console.log({products})
    return <div>
      <List
        itemLayout="vertical"
        dataSource={data.products}
        renderItem={(product, index) => {
          const selectedItems = orderItems.filter(item => item.productId === product._id).reduce((sum, item) => sum + item.quantity, 0)
          const productMaxItems = _get(product, 'maxItemsPerRegistration', 0)
          const selectDisabled = (selectedItems > 0 && productMaxItems > 0) && (selectedItems >= productMaxItems)
          // console.log({ productMaxItems, selectedItems, selectDisabled })
          // console.log({ product, selectedItems, productMaxItems })
          // getFieldDecorator(`orderItem[${index}].productId`, {
          //   initialValue: product._id
          // })
          // const quantityDecorator = getFieldDecorator(`orderItem[${index}.quantity]`, { initialValue: 1 })
          // const quantity = getFieldValue(`orderItem[${index}.quantity]`)
          // console.log(product.imageUrl)
          const actions = [
            <Button icon="shopping-cart" disabled={selectDisabled} onClick={() => this.handleSelectProduct(product._id)}>{{ en: 'Select Product', zh: 'Select Product', th: 'เลือกสินค้า' }[locale]}</Button>,
            ...(selectDisabled ? [<span>{{ en: `Limited to ${productMaxItems} / 1 registration`, zh: `Limited to ${productMaxItems} / 1 registration`, th: `จำกัด ${productMaxItems} ชิ้น / 1 ใบสมัครเท่านั้น` }[locale]}</span>] : [])
          ]
          return <List.Item
            key={product._id}
            actions={actions}
            // actions={[
            //   <React.Fragment>
            //     {product.questions.map((question, questionIndex) => {
            //       const optionField = optionFieldMap[question.kind]
            //       return <Form.Item key={question._id} style={{ width: '100px' }}>
            //         {getFieldDecorator(`orderItem[${index}].options[${questionIndex}].${optionField}`)(
            //           renderQuestionInput({ question, locale, style: { width: '100%' } })
            //         )}
            //       </Form.Item>
            //     })}
            //   </React.Fragment>]
            // }
            extra={
              <React.Fragment>
                <Tag color="blue">{<FormattedNumber value={product.price} />} THB</Tag>
                {product.imageUrl && <img src={product.imageUrl} alt={product.name.en} style={{ maxWidth: 100, maxHeight: 100, margin: 12 }}/>}
              </React.Fragment>
              // <Input.Group compact><Button icon="minus"/><InputNumber style={{ width: 60 }}/><Button icon="plus"/></Input.Group>
            }
          >
            <List.Item.Meta
              avatar={<Avatar src={product.imageUrl} />}
              title={
                <span style={{ whiteSpace: 'pre-line' }}>{localeGet(product, 'name', locale)}</span>
              }
              description={localeGet(product, 'description', locale)}
            />
          </List.Item>
        }
        }
      />
    </div>
  }
}

export default ProductSelectModal



// WEBPACK FOOTER //
// ./src/App/components/ProductSelectModal/ProductSelectModal.js